/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      slickTestimonials();

      $( window ).on( 'resize', function() {
        slickTestimonials();
      } );

      function slickTestimonials() {
        $( '.testimonials-slider' ).each( function() {
          if ( $( this ).find( '.testimonial' ).length > 3 ) {
            $( this ).find( '.slider' ).slick( {
              dots: false,
              arrows: true,
              prevArrow: $( this ).find( '.prev-slide' )[0],
              nextArrow: $( this ).find( '.next-slide' )[0],
              slidesToShow: 1,
              infinite: false,
              variableWidth: true,
            } );
          } else {
            if ( window.innerWidth < 1024 ) {
              $( this ).find( '.slider' ).slick( {
                dots: false,
                arrows: true,
                prevArrow: $( this ).find( '.prev-slide' )[0],
                nextArrow: $( this ).find( '.next-slide' )[0],
                slidesToShow: 1,
                infinite: false,
              } );

              $( this ).find( '.slider-buttons' ).removeClass( 'hidden' ).addClass( 'flex' );
            } else {
              $( this ).find( '.slider.slick-slider' ).slick( 'unslick' );
              $( this ).find( '.slider-buttons' ).addClass( 'hidden' ).removeClass( 'flex' );
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
